// @flow
import React from 'react'
import classNames from 'classnames'
import styles from './container.module.css'

type Props = {
  className?: string,
  isMain: boolean,
}

function Container({ className, isMain, ...props }: Props) {
  return (
    <div
      {...props}
      className={classNames(styles.container, className, {
        [styles.isMain]: isMain,
      })}
    />
  )
}

Container.defaultProps = {
  isMain: false,
}

export default Container
